import React from 'react';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Toolbar from 'react-big-calendar/lib/Toolbar';
import {baseUrl} from '../url';
import EventDetail from './EventDetails';
import loader from '../../assets/loader.svg';
import arrowRight from '../../assets/arrow-right.svg';
import arrowLeft from '../../assets/arrow-left.svg';

BigCalendar.momentLocalizer(moment);

class CalendarToolbar extends Toolbar {
	render() {
        const { label } = this.props;
        const currentMonth = moment().format('MMMM YYYY');
        let disabled = false;
        if(label === currentMonth){
           disabled = true;
        }
        console.log(disabled);
		return (
			<div className="toolbar">
				<div className="toolbar-buttons">
					<button onClick={() => this.navigate('PREV')}><img src={arrowLeft} alt=""/></button>
					<button>{this.props.label}</button>
					<button onClick={() => this.navigate('NEXT')}><img src={arrowRight} alt=""/></button>
				</div>
				<button className="this-month" onClick={() => this.navigate('TODAY')} disabled={disabled}>This Month</button>
			</div>
		);
	}
}

const Event = ({event})  => {
    return <EventDetail event={event} /> 
}

class Calendar extends React.Component{
    state = {
        data: [],
        entries: [],
        popoverOpen: false,
        response: true,
    }
    componentDidMount(){
        this.fetchAppointments();
    }
    formatEntries = (data) => {
        let entries = []
        data.map(item => {
            let time = moment(item.time, 'HH:mm:ss').format('hh:mm A')
            let endTime =  moment(item.time, 'HH:mm:ss').add(1, 'hours').format('HH:mm:ss');
            let entry = {
                id: item.id,
                title: `${time} - ${item.patient.name.first} ${item.patient.name.last}`,
                start: item.date + ' ' + item.time,
                end: item.date + ' ' + endTime,
                patient_name: `${item.patient.name.first} ${item.patient.name.last}`,
                patient_id: item.patient.id,
                description: item.description,
            }
            return entries = [...entries, entry]
        })
        this.setState({
            entries,
        })
    }
    fetchAppointments = () => {
        this.setState({
            response: false,
        })
        let token = localStorage.getItem('access_token');
        let retries = 0;
        fetch(`${baseUrl}/admin/appointments?view=month`,{
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            return response.json();
        })
        .then((responseJson) => {
            this.setState({
                data: responseJson.data,
                response: true,
            }, () => {this.formatEntries(this.state.data)})
        })
        .catch((error)=>{
            if (error === 401 && retries < 1){
                localStorage.getItem('access_token')
                .then(value => {
                    fetch(`${baseUrl}/token/refresh`,{
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': value
                        }
                    }).then(response => {
                        retries += 1;
                        if(response.status === 200){
                            localStorage.setItem('access_token', response.headers.get('Authorization'));
                            this.handleSubmit();
                        }
                        else{
                            alert('something went wrong please try again later');
                        }
                    })
                })
            }
			else if (error instanceof TypeError){
				console.log(error);
			}
            else{
                alert('something went wrong please try again later');
            }
        })
    }

    toggle = () => {
        this.setState({
          popoverOpen: !this.state.popoverOpen
        });
    }

    render(){
        const { entries, response } = this.state;
        return(
            <div className="calendar">
                {
                    !response &&
                    <div className="loader" style={{height: "100%"}}>
                        <img src={loader} alt=""/>
                    </div>
                }
                {
                    response &&
                    <BigCalendar
                      views={{month: true}}
                      events={entries}
                      popup={true}
                      defaultDate={new Date()}
                      eventPropGetter={
                        (event, start, end, isSelected) => {
                          let newStyle = {
                            backgroundColor: "#6C63FF",
                            color: '#FFFFFF',
                          };
                    
                          return {
                            style: newStyle
                          };
                        }
                      }
                      components={{
                        event: Event,
                        toolbar: CalendarToolbar,
                      }}
                    />
                }
            </div>
        )
    }
}

export default Calendar;


// WEBPACK FOOTER //
// ./src/components/appointments/Calendar.js